import { TypeVoie } from './TypeVoie';
export class TypeAdresse {

	public lieuDit: string;

	public ville: string;

	public voie: TypeVoie;

	public voie_e: TypeVoie;

	public cx: number;

	public cp_e: string;

	public cp: string;

	public bp: number;

	public pays: string;

	constructor() {
		this.lieuDit = '';
		this.ville = '';
		this.voie = new TypeVoie();
		this.voie_e = new TypeVoie();
		this.cx = 0;
		this.cp_e = '';
		this.cp = '';
		this.bp = 0;
		this.pays = null;

	}
}
